import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { ACTION_BTN_SIZE, ACTION_ICON_SIZE } from "@styles/common-styles";
import { Box } from "@mui-wrapper";
import { OPEN_OTHERS_TARGET_ATTRIBUTE } from "@utils/project-utils";
import { ProjectActivityEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { Link, ViewerIcon, Tooltip } from "@flat-ui";

/** Renders the actions buttons available for a background task */
export function BackgroundTaskActions(t0) {
  const $ = _c(9);
  const {
    task
  } = t0;
  const {
    trackAsyncEvent
  } = useTrackEvent();
  const url = task.viewerDeepLink;
  let t1;
  if ($[0] !== trackAsyncEvent || $[1] !== url) {
    t1 = async function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (!url) {
        return;
      }
      await trackAsyncEvent({
        name: ProjectActivityEvents.openVideoModeTrajectory,
        props: {
          openFrom: "projectActivity"
        }
      });
      window.open(url, OPEN_OTHERS_TARGET_ATTRIBUTE);
    };
    $[0] = trackAsyncEvent;
    $[1] = url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onClick = t1;
  if (!url || task.state !== "Succeeded") {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "right"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClick) {
    t3 = <SphereIconButton buttonSize={ACTION_BTN_SIZE} iconSize={ACTION_ICON_SIZE} component={ViewerIcon} onClick={onClick} />;
    $[4] = onClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3 || $[7] !== url) {
    t4 = <Box component="div" sx={t2}><Tooltip component="div" title="View capture path"><Link href={url} target={OPEN_OTHERS_TARGET_ATTRIBUTE}>{t3}</Link></Tooltip></Box>;
    $[6] = t3;
    $[7] = url;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}